import 'lazysizes'
// New Stimulus App
import { Application } from '@hotwired/stimulus'
import { accordion, tabs, accordionPreview } from '@uswitch/ev-utils/critical/components'
import '@uswitch/ev-utils/sticky-fixed'

import HomepageScrollController from './controllers/homepage-scroll-controller'
import { ModalController, ModalTriggerController } from './controllers/modal-controller'
import PostcodeFormController from './controllers/postcode-form-controller'
import PostcodeFormVariantController from './controllers/postcode-form-variant-controller'
import ScrollToPostcodeController from './controllers/scroll-to-postcode-controller'
import TabsController from './controllers/tabs-controller'
import TrackingController from './controllers/tracking-controller'
import { addDestinationFilterForEvents, sendFbTrack, hasAcceptedMarketing, trackExperiments } from './utils/track'

import '../styles/packages.scss'
import '../styles/critical.css'

accordion()
tabs()
accordionPreview()

const application = Application.start()
application.register('tracking', TrackingController)
application.register('postcode-form', PostcodeFormController)
application.register('postcode-form-variant', PostcodeFormVariantController)
application.register('scroll-to-postcode', ScrollToPostcodeController)
application.register('tabs', TabsController)
application.register('modal', ModalController)
application.register('trigger', ModalTriggerController)
application.register('homepage-scroll', HomepageScrollController)
// End Stimulus App

if (hasAcceptedMarketing()) {
  sendFbTrack()
} else if (typeof window !== 'undefined') {
  window.addEventListener('cookieConsentLoaded', () => {
    if (hasAcceptedMarketing()) {
      sendFbTrack()
    }
  })
}

addDestinationFilterForEvents([
  'Experiment Viewed',
  'Experiment Assigned',
  'Form Step Submitted',
  'Form Submitted',
  'Form Loaded',
  'Broadband Form Step Submitted',
  'Broadband Form Submitted',
  'Product List Loaded',
  'Product List Viewed',
  'Product Viewed',
  'Product Clicked',
  'Product Clickout',
  'Promotion Viewed',
  'Promotion Clicked',
  'Element Clicked',
  'Form Errored'
])

if (typeof window.nerdalytics !== 'undefined') {
  window.nerdalytics.page()
}

trackExperiments(window.__experiences)
